$(document).ready(function () {
    $(".colorbox").colorbox({ rel: 'gal', transition: "fade", width: "90%", height: "90%"});
    $(".colorbox1").colorbox({rel: 'colorbox2', transition: "fade", width: "90%", height: "90%"});
    $(".colorbox2").colorbox({rel: 'colorbox3', transition: "fade", width: "90%", height: "90%"});
    $(".colorbox3").colorbox({rel: 'colorbox4', transition: "fade", width: "90%", height: "90%"});
    $(".colorbox4").colorbox({rel: 'colorbox5', transition: "fade", width: "90%", height: "90%"});
});
